<template>
  <section>
    <div class="hero">
      <img
        class="lady"
        :src="require('../assets/sign-in/ADPUZL-email-verify-2.svg')"
        width="700"
        height="525"
        alt="Lady with giant magnifying glass"
      />
      <transition name="zoom-in" appear>
        <img
          class="mail"
          :src="require('../assets/sign-in/ADPUZL-email-verify-1.svg')"
          width="700"
          height="525"
          alt="Incoming mail"
        />
      </transition>
    </div>
    <div class="form-container">
      <div class="logo">
        <img
          :src="require('../assets/logo-horizontal.svg')"
          alt="AdPuzl Logo"
          width="230"
          height="60"
        />
      </div>
      <div class="check-email">
        <h1>Check your email</h1>
        <h2>
          {{ currentRoute.message }}
        </h2>
      </div>
      <h3 class="alternate-message">
        Didn’t get the email?
        <el-button
          style="padding: 0.5em 1.2em"
          size="medium"
          type="info"
          @click="resend"
          :loading="resending"
          >RESEND</el-button
        >
      </h3>
      <div class="alternate-option">
        Continue to <router-link :to="{ path: '/login' }">Login</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    resendData: Object,
  },
  data: () => ({
    currentRoute: null,
    routeOptions: {
      "sign-up": {
        message:
          "Please confirm your account by clicking the verification link in your email.",
        resendAction: "reconfirmEmail",
        resentMessage: "Your confirmation email has been re-sent!",
      },
      forgot: {
        message: "Please check your email to reset your password.",
        resendAction: "resetPassword",
        resentMessage: "Your password reset email has been re-sent!",
      },
    },
    resending: false,
  }),
  created() {
    this.currentRoute = { ...this.routeOptions[this.$route.name] };
  },
  methods: {
    async resend() {
      this.resending = true;
      const res = await this.$store.dispatch(
        `auth/${this.currentRoute.resendAction}`,
        this.resendData
      );
      this.resending = false;
      if (res) {
        this.$alert(this.currentRoute.resentMessage);
      }
    },
  },
};
</script>

<style scoped>
.check-email {
  background: var(--clouds);
  padding: 2em;
  border-radius: 6px;
  margin: 1em 0;
}

.hero {
  position: relative;
}

.centered-card .hero .lady {
  position: relative;
  z-index: 10;
}
.centered-card .hero .mail {
  position: absolute;
  left: 0;
  top: 0;
}

.zoom-in-enter-active {
  animation: zoomIn 1500ms;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 500px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -30px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
</style>
